
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/parking/booking/new/confirmation",
      function () {
        return require("private-next-pages/[locale]/parking/booking/new/confirmation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/parking/booking/new/confirmation"])
      });
    }
  